// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../chevron-left.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts: loaded by Shopify theme (product-component-fonts.css) or public/product-component-fonts.css in local dev */

/* Brand background: two large, soft, blurred colour "dots" pinned statically in
   opposite corners (top-left and bottom-right). They use a radial-gradient fade
   instead of a huge blur filter so painting stays cheap on mobile. */
#react-product .brand-dot {
  position: absolute;
  top: 0;
  left: 0;
  width: clamp(820px, 120vw, 1800px);
  height: clamp(820px, 120vw, 1800px);
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.38;
  pointer-events: none;
  transition: background 0.7s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (prefers-reduced-motion: reduce) {
  #react-product .brand-dot {
    transition: none;
  }
}

/* Faint square grid over the same backdrop, as a texture rather than a feature: at
   3.5% white on near-black it lands about four values above the background, enough
   to give the black some structure without competing with anything on top of it.
   Two repeating gradients rather than an image, so it stays crisp at any DPR. */
#react-product .brand-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(to right, rgba(255, 255, 255, 0.035) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(255, 255, 255, 0.035) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
}

/* Selector tiles (experiences, age groups). The tile box carries 4px of padding that
   .track-tile__ring fills, so a selected tile reads as a gradient-ringed card; the
   media sits above the ring and eases in on select. Only tiles that own a click
   handler get .track-tile--interactive, keeping the static review/upsell banners flat. */
#react-product .track-tile {
  transition:
    transform 200ms cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

#react-product .track-tile__ring {
  opacity: 0;
  transition: opacity 300ms cubic-bezier(0.4, 0, 0.2, 1);
}

#react-product .track-tile__media {
  transition: transform 500ms cubic-bezier(0.4, 0, 0.2, 1);
}

#react-product .track-tile--selected .track-tile__ring {
  opacity: 1;
}

#react-product .track-tile--selected .track-tile__media {
  transform: scale(1.05);
}

#react-product .track-tile--interactive:active {
  transform: scale(0.985);
}

#react-product .track-tile--interactive:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 3px;
}

/* Idle hint that the tiles are pickable, offset per tile by --track-tile-wave-index
   so it travels the grid. It glows rather than touching .track-tile__ring: the ring
   means "selected", so pulsing it here made unchosen tiles read as chosen on a screen
   whose whole job is showing which ones you picked.

   Deliberately finite. It runs a few passes, then stops, and it is withdrawn entirely
   once the user engages — a loop on a primary selection screen sits in the corner of
   the eye while people are trying to read age ranges and height limits, and never lets
   the device settle. The ramp is slow and the peak sits below the hover glow, so it
   breathes instead of blinking and never outshines a real interaction.

   The stagger is kept near a third of the 1.2s pulse: much tighter and the four tiles
   glow in unison, which reads as the grid breathing rather than one crest travelling
   from the first tile to the last. */
@keyframes track-tile-hint-glow {
  0%,
  33%,
  100% {
    box-shadow: 0 0 0 0 rgba(211, 46, 254, 0);
  }

  17% {
    box-shadow: 0 0 22px 4px rgba(211, 46, 254, 0.3);
  }
}

#react-product .track-tile--waving:not(.track-tile--selected) {
  animation: track-tile-hint-glow 3.6s ease-in-out 3;
  animation-delay: calc(0.9s + 0 * 0.45s);
  animation-delay: calc(0.9s + var(--track-tile-wave-index, 0) * 0.45s);
}

/* Hover previews the ring at half strength. Gated on a real pointer so touch devices
   don't latch the hover state after a tap. */
@media (hover: hover) and (pointer: fine) {
  /* Deliberately does NOT cancel the hint animation. Suppressing it from inside the
     hover rule looks right but re-applies the declaration the instant the pointer
     leaves, and the browser then restarts the hint from its first pass — so the tile
     glowed for another ten seconds with nothing on it, and every sweep of the mouse
     across the row wound all four tiles up again. The tile retires the hint in React
     on first pointer or keyboard contact instead, which cannot be undone by leaving. */
  #react-product .track-tile--interactive:hover {
    transform: scale(1.015);
    box-shadow: 0 12px 32px rgba(211, 46, 254, 0.32);
  }

  #react-product .track-tile--interactive:not(.track-tile--selected):hover .track-tile__ring {
    opacity: 0.5;
  }

  #react-product .track-tile--interactive:not(.track-tile--selected):hover .track-tile__media {
    transform: scale(1.03);
  }
}

/* Room for the glow to land in, kept next to the shadow so the two stay in step.
   Both selector grids scroll inside a container that clips at its own edges, and the
   outermost tiles sit hard against them, so those tiles lost the outer half of their
   glow: Adult Track had none to its left and Mini Track none to its right, while the
   tiles between them looked right, and the same hover therefore read differently
   depending on which tile you were on. 36px is the hover shadow's 32px blur radius
   plus the few pixels the 1.5% hover scale adds on the widest (filling) tiles.

   Sideways only, and not on phones. This screen's vertical space is budgeted to fit
   four tiles without scrolling (tileHeight in RacingTrackSelection), so padding the
   rows would push them into a scroll. A phone cannot spare 72px of tile width either,
   and it loses little by going without: the hover glow needs a fine pointer, so a
   touch device never paints one, and the fainter idle hint reads fine trailing off the
   edge of tiles that already run nearly full-bleed. */
@media (min-width: 640px) {
  #react-product .selector-tile-grid {
    padding-left: 36px;
    padding-right: 36px;
  }
}

@media (prefers-reduced-motion: reduce) {
  #react-product .track-tile,
  #react-product .track-tile__ring,
  #react-product .track-tile__media {
    transition: none;
  }

  #react-product .track-tile--waving {
    animation: none;
  }

  #react-product .track-tile--interactive:hover,
  #react-product .track-tile--interactive:active,
  #react-product .track-tile--selected .track-tile__media {
    transform: none;
  }
}

.swiper-pagination-battle-kart > .swiper-pagination-bullet-active {
  background: #ea581a !important;
}

.swiper-pagination-primary-track > .swiper-pagination-bullet {
  background: #7886ff !important;
}

#react-product {
  container-type: inline-size;
}

#react-product .option-label {
  height: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: #2f1160;
}

#react-product p.uppercase {
  text-transform: uppercase;
}
#react-product .progress-bar-arrow {
  position: absolute;
  top: 0;
  right: 0;
  shape-outside: polygon(0 0, 100% 0, 50% 100%, 0 0);
  -webkit-clip-path: polygon(0 0, 100% 0, 50% 100%, 0 0);
          clip-path: polygon(0 0, 100% 0, 50% 100%, 0 0);
  background: linear-gradient(to right, #e045ff 0%, #e045ff 90%);
  width: 30px;
  height: 30px;
}

#react-product .bg-gradient-1 {
  background: linear-gradient(126.78deg, #9d62fe 35%, #7886ff 119.7%);
}

#react-product .bg-gradient-2 {
  background: linear-gradient(96.73deg, #9d62fe 9.22%, #a852ff 31.45%, #ad44ff 50.38%, #7886ff 88.25%);
}

/* Phase 2 theme styling — driven by --booking-* CSS vars from data-styling-config */
.booking-cta-pill {
  background: linear-gradient(270deg, #f908ff 0%, #d32efe 8.19%, #37ccfb 87.88%, #05fffa 100%);
  background: var(--booking-cta-bg, linear-gradient(270deg, #f908ff 0%, #d32efe 8.19%, #37ccfb 87.88%, #05fffa 100%));
  border-radius: 9999px;
  border-radius: var(--booking-cta-radius, 9999px);
  font-size: 14px;
  font-size: var(--booking-cta-font-size, 14px);
  color: #ffffff;
  color: var(--booking-cta-color, #ffffff);
}

/* Disabled Next/Checkout: solid grey in place of the CTA background, never a dimmed CTA.
   The label colour is scoped under #react-product so it beats the buttons' tw-text-white. */
.booking-cta-pill-disabled {
  background: #4a4c52;
  background: var(--booking-cta-disabled-bg, #4a4c52);
  border-radius: 9999px;
  border-radius: var(--booking-cta-radius, 9999px);
  font-size: 14px;
  font-size: var(--booking-cta-font-size, 14px);
}
#react-product .booking-cta-pill-disabled,
#react-product .booking-cta-pill-disabled * {
  color: #a1a3a9;
  color: var(--booking-cta-disabled-color, #a1a3a9);
}

/* The outline is what separates Back from a disabled Next, which shares its grey fill.
   Inset shadow rather than a border so the pill keeps its height. */
.booking-prev-pill {
  background: #4a4c52;
  background: var(--booking-prev-bg, #4a4c52);
  border-radius: 9999px;
  border-radius: var(--booking-prev-radius, 9999px);
  font-size: 14px;
  font-size: var(--booking-cta-font-size, 14px);
  color: #ffffff;
  color: var(--booking-prev-color, #ffffff);
  box-shadow: inset 0 0 0 1.5px rgba(255, 255, 255, 0.7);
  box-shadow: inset 0 0 0 1.5px var(--booking-prev-border, rgba(255, 255, 255, 0.7));
  transition: filter 0.2s;
}
.booking-prev-pill:hover {
  filter: brightness(1.2);
}

/* Square on every edge — the expanded summary panel owns the rounding. */
.booking-sticky-bar {
  background: #393b41;
  background: var(--booking-sticky-bg, #393b41);
}

/* Summary surfaces that never take the desktop accent: the expanded panel body and the
   desktop nav bar flanking it. */
.booking-sticky-surface {
  background: #393b41;
  background: var(--booking-sticky-bg, #393b41);
}

/* Collapsed experience-variant bar blends into the page; desktop keeps the accent below. */
.booking-sticky-bar.booking-sticky-bar--transparent {
  background: transparent;
}

/* Only the full desktop footer (from the \`desktop\` breakpoint) gets the accent bar; below it the
   footer is the compact mobile/tablet one and stays transparent. */
@media (min-width: 1380px) {
  /* The accent is a collapsed-only treatment. Once expanded, these surfaces sit against
     the summary panel, so they take the same base colour instead. */
  .booking-sticky-bar:not(.booking-sticky-bar--expanded) {
    background: #9d62fe;
    background: var(--booking-sticky-desktop-accent, var(--booking-sticky-bg, #9d62fe));
  }
}

.booking-track-pill {
  background: linear-gradient(90deg, #00ffff 0%, #ff00ff 100%);
  background: var(--booking-pill-bg, linear-gradient(90deg, #00ffff 0%, #ff00ff 100%));
  color: #ffffff;
  color: var(--booking-pill-color, #ffffff);
  font-size: 13px;
  font-size: var(--booking-pill-font-size, 13px);
  border-radius: 9999px;
  border-radius: var(--booking-pill-radius, 9999px);
}

#react-product .bg-gradient-3 {
  background: linear-gradient(126.78deg, #9d62fe 35%, #7886ff 119.7%);
}

#react-product .selected-swatch-gradient {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);
}

#react-product .selected-swatch-gradient-1 {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

#react-product .price_15 {
  background: #40bfff;
}

#react-product .price_19 {
  background: #40bfff;
}

#react-product .price_24 {
  background: #659aff;
}

#react-product .price_29 {
  background: #8a75ff;
}

#react-product .price_34 {
  background: #a95ff6;
}

#react-product .price_39 {
  background: #c748ee;
}

#react-product .price_44 {
  background: #e632e5;
}

#react-product .price_49 {
  background: #ff00ff;
}

#react-product .price_54 {
  background: #ff0090;
}

#react-product .price_59 {
  background: #ff0054;
}
#react-product .price_69 {
  background: #bb1af9;
}

#react-product .price_250 {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);
}
#react-product .price_442 {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);
}

#react-product .mini-track.price_9 {
  background: #89d1f9;
}

#react-product .mini-track.price_14 {
  background: #8a8df7;
}

#react-product .mini-track.price_15 {
  background: #8a8df7;
}

#react-product .mini-track.price_19 {
  background: #c64af7;
}

#react-product .mini-track.price_24 {
  background: #a9cdf3;
}

#react-product .mini-track.price_29 {
  background: #83bcf9;
}

#react-product .border-color {
  position: relative;
  overflow: hidden;
  z-index: 39;
  background-image: linear-gradient(282.87deg, #d32efe 14.09%, #05fffa 103.26%);
  box-shadow: 0 4px 12px rgba(211, 46, 254, 0.3);
  transform: scale(1.02);
}

#react-product .border-color .time {
  /* background: #fff; */
  height: 100%;
  /* display: flex;
    align-items: center;
    justify-content: center; */
  width: 100%;
  margin: auto;
  /* border-radius: 0.25rem; */
  z-index: 99;
}

#react-product .border-color .price-variant {
  z-index: 5;
}

#react-product .arrow-up {
  transform: rotate(180deg);
}

#react-product .block {
  margin-bottom: 0 !important;
}

#react-product .bg-gradient-4 {
  background: linear-gradient(88.14deg, #ffb82e 18.41%, #ffe600 78.18%);
}
#react-product .box-0 {
  grid-column: auto / span 2;
}
#react-product .bg-gradient {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%) !important;
}
#react-product .bg-gradient > div > div {
  color: #fff;
  background-color: transparent !important;
}
#react-product .tw-bg-transparent {
  background-color: rgba(57, 59, 65, 0) !important;
}
#react-product .bg-one {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);
  opacity: 0.05;
  border-radius: 60px;
  padding: 2.61px 3.19px;
}

#react-product .bg-two {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);
  opacity: 0.1;
  border-radius: 60px;
  padding: 2.5px 2.99px;
}

#react-product .bg-three {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);
  opacity: 0.1;
  border-radius: 34px;
  padding: 2.36px 3.29px;
}

#react-product .bg-four {
  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);
  opacity: 0.15;
  border-radius: 34px;
  padding: 3.13px 4.26px;
}

#react-product .arrow.is-top {
  transform: rotate(225deg);
}
#react-product .arrow {
  display: inline-block;
  height: 16px;
  position: absolute;
  width: 16px;
  top: -8px;
  z-index: 9;
  right: 42px;
}
#react-product .arrow.is-triangle::after {
  border-style: solid;
  border-width: 0 0 16px 16px;
  height: 0;
  width: 0;
  border-color: transparent;
  border-bottom-color: #393b41;
  left: 0;
  position: absolute;
  top: 0;
  content: "";
  display: inline-block;
}
#react-product .filter {
  filter: drop-shadow(0px 0px 40px rgba(0, 0, 0, 0.1));
}

/* removing library styles */

#react-product .calender.rdrCalendarWrapper {
  background-color: transparent !important;
  background-color: initial !important;
}
#react-product .calender .rdrDayNumber span {
  color: inherit !important;
}
#react-product .calender .rdrSelected {
  color: inherit !important;
}

/* removing library styles end */

#react-product .calender .rdrDateDisplayWrapper {
  display: none;
}
#react-product .calender .rdrMonthAndYearWrapper {
  padding: 10px 20px;
  height: auto;
  background-color: #f3f4f7;
  display: none;
}
#react-product .calender .rdrMonth {
  padding: 0;
}
#react-product .calender .rdrWeekDays {
  margin-top: 0.5em;
  margin-bottom: 0.3em;
  background-color: #000000;
  color: #c2c0c3;
  justify-content: space-between;
  padding: 15px 20px !important;
  display: flex;
  gap: 20px;
}
#react-product .calender .rdrWeekDay {
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  color: #c2c0c3;
  flex-basis: calc(100% / 9);
}
@container (min-width: 1024px) {
  #react-product .calender .rdrWeekDay {
    font-size: 18px;
  }
}

#react-product .calender .rdrDay {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
#react-product .calender .rdrDayNumber {
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
  color: white;
}
@container (min-width: 1024px) {
  #react-product .calender .rdrDayNumber {
    font-size: 20px;
  }
}
#react-product .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
#react-product .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
#react-product .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
#react-product .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
  color: #fdfdfd !important;
}
#react-product .calender .rdrDayToday .rdrDayNumber span:after {
  background: linear-gradient(126.78deg, #9d62fe 35%, #7886ff 119.7%);
  bottom: 2px;
}
#react-product .calender .rdrDays {
  padding: 20px;
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto;
  justify-content: space-between;
  grid-row-gap: 28px;
  row-gap: 28px;
}
@media screen and (max-width: 1024px), (hover: none) and (pointer: coarse) and (max-width: 1379px) {
  #react-product .calender .rdrDays {
    row-gap: 10px;
    padding: 10px;
  }
}
#react-product .calender button.rdrDay {
  padding: 17px 18px;
}
#react-product .calender button.rdrDay.rdrDayDisabled .rdrDayNumber {
  color: gray;
}

#react-product .calender button:not(.rdrDayDisabled):not(:has(.rdrSelected)):not(:has(.rdrDayActive)):has(.custom-pricing-cheapest) {
  background: #01a698 !important;
  color: white !important;
}

#react-product .calender button:not(.rdrDayDisabled):not(:has(.rdrSelected)):not(:has(.rdrDayActive)):has(.custom-pricing-medium) {
  background: #ff9400 !important;
  color: white !important;
}

#react-product .calender button:not(.rdrDayDisabled):not(:has(.rdrSelected)):not(:has(.rdrDayActive)):has(.custom-pricing-expensive) {
  background: #d1435b !important;
  color: white !important;
}

/* Dotted outline on Main Track Sprint dates (weekends and holidays), including
   the neighbouring month's days shown at the edges of the grid. Drawn on ::after
   so it follows the circular day cell without shifting the existing layout. */
#react-product .calender button.rdrDay:has(.sprint-track-day) {
  position: relative;
}
#react-product .calender button.rdrDay:has(.sprint-track-day)::after {
  content: "";
  position: absolute;
  inset: 0;
  border: 2px dotted #ffffff;
  border-radius: 100%;
  pointer-events: none;
}

#react-product .calender button:has(.rdrSelected),
#react-product .calender button:has(.rdrDayActive),
#react-product .calender .rdrInRange,
#react-product .calender .rdrStartEdge,
#react-product .calender .rdrEndEdge {
  top: 0;
  border-radius: 100%;
  background: linear-gradient(126.78deg, #9d62fe 35%, #7886ff 119.7%) !important;
  color: transparent !important;
  width: 32px;
  height: 25.6px;
  display: flex;
}

#react-product .calender.battle-kart .rdrDayNumber {
  font-family: "Source Sans Pro", sans-serif !important;
}
#react-product .calender .rdrNextPrevButton {
  margin: 0;
  width: 34px;
  height: 34px;
  background: rgba(157, 98, 254, 0.15);
  border-radius: 8px;
}
#react-product .calender .rdrMonthAndYearPickers {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #000000;
}
#react-product .calender .rdrNextPrevButton i {
  display: none;
}
#react-product .calender .rdrPprevButton,
#react-product .calender .rdrNextButton {
  position: relative;
}
#react-product .calender .rdrPprevButton::after,
#react-product .calender .rdrNextButton::after {
  position: absolute;
  content: "";
  left: 50%;
  top: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 14px;
  height: 14px;
  background-repeat: no-repeat;
  transform: translate(-50%, -50%);
  background-position: center center;
}
#react-product .calender .rdrNextButton {
  transform: rotate(180deg);
}

#react-product table,
#react-product td {
  border: 1px solid black;
  border-collapse: collapse;
}
#react-product td {
  padding: 1rem;
}

#react-product .info-li {
  display: list-item;
  margin-left: 2rem;
  list-style-type: disc;
}

#react-product .banner-img {
  min-width: 100%;
  border: none;
  overflow: hidden;
  padding: 0;
}

@container (max-width: 590px) {
  #react-product .font-race-champion {
    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  #react-product .font-race-season {
    font-size: 0.95rem;
    line-height: 1.09rem;
  }

  #react-product .font-race-option-label {
    font-size: 1.4rem;
    line-height: 2.1rem;
  }

  #react-product .font-race-accordian-xl {
    font-size: 1.6rem;
    line-height: 1.96rem;
  }

  #react-product .font-race-variant-xs {
    font-size: 0.8rem;
    line-height: 1.1rem;
  }

#react-product .main-track-variant .price-variant,
#react-product .main-track-variant .seats-left {
  padding-top: 0;
  padding-bottom: 0;
  line-height: 1;
}

#react-product .main-track-variant .seats-left {
  display: flex;
  align-items: center;
}

#react-product .main-track-variant .seats-left .font-race-variant-xs {
  line-height: 1;
}

  #react-product .font-race-variant-xs-date,
  #react-product .font-race-variant-xs-time {
    font-size: 1.1rem;
    line-height: 1.4rem;
  }

  #react-product .min-height-variant {
    min-height: 57px;
  }

  #react-product .padding-t-date {
    padding-top: 0.8rem;
  }

  #react-product .padding-b-time {
    padding-bottom: 0.8rem;
  }

  #react-product .padding-t-date-click {
    padding-top: 1.4rem;
  }

  #react-product .padding-b-time-click {
    padding-bottom: 1.4rem;
  }

  #react-product .padding-t-var-block {
    padding-top: 4rem;
  }

  #react-product .w-down-icon {
    width: 9%;
  }
}

@container (min-width: 600px) {
  #react-product .font-race-season {
    font-size: 1rem;
    line-height: 1.15rem;
  }

  #react-product .font-race-bg {
    font-size: 1.8rem;
    line-height: 2.8rem;
  }

  #react-product .font-race-accordian-xl {
    font-size: 2rem;
    line-height: 2.4rem;
  }

  #react-product .font-race-variant-xs {
    font-size: 1.1rem;
    line-height: 1.6rem;
  }

  #react-product .font-race-variant-xs-date {
    font-size: 1.4rem;
    line-height: 2rem;
  }

  #react-product .font-race-variant-xs-time {
    font-size: 1.2rem;
    line-height: 1.6rem;
  }

  #react-product .padding-t-date {
    padding-top: 1.4rem;
  }

  #react-product .padding-b-time {
    padding-bottom: 1.4rem;
  }

  #react-product .padding-t-date-click {
    padding-top: 1.6rem;
  }

  #react-product .padding-b-time-click {
    padding-bottom: 1.6rem;
  }

  #react-product .min-height-variant {
    min-height: 68px;
  }

  #react-product .padding-t-var-block {
    padding-top: 6.4rem;
  }

  #react-product .font-race-champion {
    font-size: 1.8rem;
    line-height: 2.8rem;
  }

  #react-product .w-down-icon {
    width: 2.4rem;
  }
}

/* Medium containers (tablets) */
@container (min-width: 768px) and (max-width: 1023px) {
  #react-product .prod-banner-text-align {
    text-align: center;
  }

  #react-product .prod-banner-text {
    font-size: 36px;
  }

  #react-product .prod-banner-subtext {
    font-size: 2.4rem;
    line-height: 2.8rem;
  }

  #react-product .font-race-season {
    font-size: 0.95rem;
    line-height: 1.09rem;
  }
}

/* Large containers (iPad-sized) */
@container (min-width: 1024px) and (max-width: 1279px) {
  #react-product .heading {
    padding-top: 2rem;
  }

  #react-product .font-race-season {
    font-size: 0.95rem;
    line-height: 1.09rem;
  }

  #react-product .prod-banner-text-align {
    text-align: center;
  }

  #react-product .prod-banner-text {
    font-size: 36px;
  }

  #react-product .prod-banner-subtext {
    font-size: 2.4rem;
    line-height: 2.8rem;
  }
}

/* Extra large containers (Desktop) */
@container (min-width: 1280px) {
  #react-product .font-race-season {
    font-size: 1rem;
    line-height: 1.15rem;
  }

  #react-product .heading {
    padding-top: 6.4rem;
    padding-bottom: 3.6rem;
  }

  #react-product .prod-banner-text-align {
    text-align: justify;
  }

  #react-product .prod-banner-text {
    font-size: 76px;
  }

  #react-product .prod-banner-subtext {
    font-size: 3.6rem;
    line-height: 4rem;
  }
}

/* Small to medium containers */
@container (min-width: 350px) and (max-width: 1366px) {
  #react-product .prod-banner-text-align {
    text-align: center;
  }

  #react-product .prod-banner-text {
    font-size: 36px;
  }

  #react-product .prod-banner-subtext {
    font-size: 2.4rem;
    line-height: 2.8rem;
  }
}

/* Narrow containers */
@container (min-width: 350px) and (max-width: 920px) {
  #react-product .heading {
    padding-top: 2rem;
  }

  #react-product .font-race-season {
    font-size: 0.95rem;
    line-height: 1.09rem;
  }
}

#react-product .font-race-lg {
  font-size: 1.8rem;
  line-height: 2.8rem;
}

#react-product .font-race-xl {
  font-size: 2rem;
  line-height: 2.4rem;
}

#react-product .font-race-2xl {
  font-size: 2.4rem;
  line-height: 2.8rem;
}

#react-product .font-race-4xl {
  font-size: 3.6rem;
  line-height: 4rem;
}

#react-product .font-race-sm {
  font-size: 1.4rem;
  line-height: 2rem;
}

#react-product .font-race-base {
  font-size: 1.6rem;
  line-height: 2.4rem;
}

#react-product .font-race-xs {
  font-size: 1.2rem;
  line-height: 1.6rem;
}

#react-product .padding-x-2 {
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}

#react-product .padding-x-2\\.5 {
  padding-left: 1rem;
  padding-right: 1rem;
}

#react-product .padding-x-3 {
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}

#react-product .padding-1 {
  padding: 0.4rem;
}

#react-product .padding-1\\.5 {
  padding: 0.6rem;
}

#react-product .padding-4 {
  padding: 1.6rem;
}

#react-product .padding-l-5 {
  padding-left: 2rem;
}

#react-product .gap-1\\.5 {
  gap: 0.6rem;
}

#react-product .gap-2 {
  gap: 0.8rem;
}

#react-product .gap-3 {
  gap: 1.2rem;
}

#react-product .gap-3\\.5 {
  gap: 1.4rem;
}

#react-product .padding-y-1 {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}

#react-product .padding-y-2 {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
}

#react-product .padding-y-2\\.5 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

#react-product .padding-x-4 {
  padding-left: 1.6rem;
  padding-right: 1.6rem;
}

#react-product .padding-x-5 {
  padding-left: 2rem;
  padding-right: 2rem;
}
#react-product .padding-y-3 {
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
}

#react-product .padding-y-4 {
  padding-top: 1.6rem;
  padding-bottom: 1.6rem;
}

#react-product .padding-x-10 {
  padding-left: 4rem;
  padding-right: 4rem;
}

#react-product .padding-x-14 {
  padding-left: 5rem;
  padding-right: 5rem;
}

#react-product .padding-x-16 {
  padding-left: 6.4rem;
  padding-right: 6.4rem;
}

#react-product .padding-t-2\\.5 {
  padding-top: 1rem;
}

#react-product .padding-t-4 {
  padding-top: 1.6rem;
}

#react-product .padding-b-16 {
  padding-bottom: 6.4rem;
}

#react-product .max-width-block {
  max-width: 44.8rem;
}

#react-product .width-6 {
  width: 2.4rem;
}

#react-product .height-6 {
  height: 2.4rem;
}

#react-product .rounded-xl {
  border-radius: 1.2rem;
}

#react-product .rounded {
  border-radius: 0.4rem;
}

#react-product .rounded-t {
  border-top-left-radius: 0.4rem;
  border-top-right-radius: 0.4rem;
}

#react-product .rounded-bl {
  border-bottom-left-radius: 0.4rem;
}
#react-product .rounded-br {
  border-bottom-right-radius: 0.4rem;
}

/* Touch tablets get the small-iPad layout (see TOUCH_TABLET_QUERY in layoutViewport.ts),
   so the page container stops at the small-iPad width too. */
@media (hover: none) and (pointer: coarse) and (max-width: 1379px) {
  #react-product .tw-container {
    max-width: 768px;
  }
}

/* Mobile-specific enhancements */
@media (max-width: 768px), (hover: none) and (pointer: coarse) and (max-width: 1379px) {
  #react-product .border-color {
    box-shadow: 0 6px 16px rgba(211, 46, 254, 0.4);
    transform: scale(1.03);
  }

  /* Improve touch targets */
  #react-product .variant-block {
    min-height: 60px !important;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  /* Better visual feedback for selected state */
  #react-product .variant-block.selected {
    border: 2px solid #d32efe;
    box-shadow: 0 4px 12px rgba(211, 46, 254, 0.3);
  }

  /* Pressed state for better touch feedback */
  #react-product .variant-block:active {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }

  /* Prevent text selection on touch */
  #react-product .variant-block {
    -webkit-user-select: none;
    user-select: none;
  }

  /* Prevent Swiper from interfering with variant block clicks */
  #react-product .swiper-slide {
    touch-action: pan-y;
  }

  #react-product .swiper-slide > div {
    touch-action: manipulation;
  }

  /* Ensure variant blocks have proper touch handling */
  #react-product .swiper-slide .tw-touch-manipulation {
    touch-action: manipulation !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  /* Prevent Swiper pagination from interfering */
  #react-product .swiper-pagination {
    pointer-events: auto;
    touch-action: manipulation;
  }

  #react-product .swiper-pagination-bullet {
    touch-action: manipulation;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/App.css"],"names":[],"mappings":"AAAA,oHAAoH;;AAEpH;;qEAEqE;AACrE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;gFAGgF;AAChF;EACE,kBAAkB;EAClB,QAAQ;EACR;;+EAE6E;EAC7E,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;;yFAGyF;AACzF;EACE;;iDAE+C;AACjD;;AAEA;EACE,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;qCAaqC;AACrC;EACE;;;IAGE,yCAAyC;EAC3C;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,kDAAkD;EAClD,uCAAqE;EAArE,qEAAqE;AACvE;;AAEA;6CAC6C;AAC7C;EACE;;;;;uFAKqF;EACrF;IACE,uBAAuB;IACvB,gDAAgD;EAClD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;;;;;;;;;;;;;sDAasD;AACtD;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,kDAAkD;EAClD,sDAA8C;UAA9C,8CAA8C;EAC9C,8DAA8D;EAC9D,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,oGAAoG;AACtG;;AAEA,oFAAoF;AACpF;EACE,4FAAmH;EAAnH,mHAAmH;EACnH,qBAAgD;EAAhD,gDAAgD;EAChD,eAA6C;EAA7C,6CAA6C;EAC7C,cAAwC;EAAxC,wCAAwC;AAC1C;;AAEA;4FAC4F;AAC5F;EACE,mBAAmD;EAAnD,mDAAmD;EACnD,qBAAgD;EAAhD,gDAAgD;EAChD,eAA6C;EAA7C,6CAA6C;AAC/C;AACA;;EAEE,cAAiD;EAAjD,iDAAiD;AACnD;;AAEA;oEACoE;AACpE;EACE,mBAA2C;EAA3C,2CAA2C;EAC3C,qBAAiD;EAAjD,iDAAiD;EACjD,eAA6C;EAA7C,6CAA6C;EAC7C,cAAyC;EAAzC,yCAAyC;EACzC,sDAAkF;EAAlF,kFAAkF;EAClF,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;EACE,mBAA6C;EAA7C,6CAA6C;AAC/C;;AAEA;iCACiC;AACjC;EACE,mBAA6C;EAA7C,6CAA6C;AAC/C;;AAEA,2FAA2F;AAC3F;EACE,uBAAuB;AACzB;;AAEA;mEACmE;AACnE;EACE;oEACkE;EAClE;IACE,mBAAmF;IAAnF,mFAAmF;EACrF;AACF;;AAEA;EACE,4DAAoF;EAApF,oFAAoF;EACpF,cAAyC;EAAzC,yCAAyC;EACzC,eAA8C;EAA9C,8CAA8C;EAC9C,qBAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,sGAAsG;AACxG;;AAEA;EACE,sGAAsG;EACtG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,sGAAsG;AACxG;AACA;EACE,sGAAsG;AACxG;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6EAA6E;EAC7E,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ;;8BAE4B;EAC5B,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qEAAqE;AACvE;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iHAAiH;AACnH;AACA;EACE,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,sGAAsG;EACtG,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sGAAsG;EACtG,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sGAAsG;EACtG,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sGAAsG;EACtG,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,4BAA4B;EAC5B,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,oDAAoD;AACtD;;AAEA,4BAA4B;;AAE5B;EACE,wCAAkC;EAAlC,oCAAkC;AACpC;AACA;EACE,yBAAuB;AACzB;AACA;EACE,yBAAuB;AACzB;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,mEAAmE;EACnE,WAAW;AACb;AACA;EACE,aAAa;EACb,aAAa;EACb,yDAAyD;EACzD,8BAA8B;EAC9B,kBAAa;EAAb,aAAa;AACf;AACA;EACE;IACE,aAAa;IACb,aAAa;EACf;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;8EAE8E;AAC9E;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;;EAKE,MAAM;EACN,mBAAmB;EACnB,8EAA8E;EAC9E,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qDAAqD;AACvD;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,yDAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;AAEF;;EAEE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;EAEE;;IAEE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;;AAEA;6DAC6D;AAC7D;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,8CAA8C;IAC9C,sBAAsB;EACxB;;EAEA,0BAA0B;EAC1B;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,wCAAwC;EAC1C;;EAEA,8CAA8C;EAC9C;IACE,yBAAyB;IACzB,8CAA8C;EAChD;;EAEA,4CAA4C;EAC5C;IACE,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA,oCAAoC;EACpC;IACE,yBAAyB;IAGzB,iBAAiB;EACnB;;EAEA,8DAA8D;EAC9D;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,qDAAqD;EACrD;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,yBAAyB;IAIzB,iBAAiB;IACjB,wCAAwC;EAC1C;;EAEA,+CAA+C;EAC/C;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Fonts: loaded by Shopify theme (product-component-fonts.css) or public/product-component-fonts.css in local dev */\n\n/* Brand background: two large, soft, blurred colour \"dots\" pinned statically in\n   opposite corners (top-left and bottom-right). They use a radial-gradient fade\n   instead of a huge blur filter so painting stays cheap on mobile. */\n#react-product .brand-dot {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: clamp(820px, 120vw, 1800px);\n  height: clamp(820px, 120vw, 1800px);\n  border-radius: 50%;\n  filter: blur(120px);\n  opacity: 0.38;\n  pointer-events: none;\n  transition: background 0.7s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  #react-product .brand-dot {\n    transition: none;\n  }\n}\n\n/* Faint square grid over the same backdrop, as a texture rather than a feature: at\n   3.5% white on near-black it lands about four values above the background, enough\n   to give the black some structure without competing with anything on top of it.\n   Two repeating gradients rather than an image, so it stays crisp at any DPR. */\n#react-product .brand-grid {\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(to right, rgba(255, 255, 255, 0.035) 1px, transparent 1px),\n    linear-gradient(to bottom, rgba(255, 255, 255, 0.035) 1px, transparent 1px);\n  background-size: 48px 48px;\n  pointer-events: none;\n}\n\n/* Selector tiles (experiences, age groups). The tile box carries 4px of padding that\n   .track-tile__ring fills, so a selected tile reads as a gradient-ringed card; the\n   media sits above the ring and eases in on select. Only tiles that own a click\n   handler get .track-tile--interactive, keeping the static review/upsell banners flat. */\n#react-product .track-tile {\n  transition:\n    transform 200ms cubic-bezier(0.4, 0, 0.2, 1),\n    box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n#react-product .track-tile__ring {\n  opacity: 0;\n  transition: opacity 300ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n#react-product .track-tile__media {\n  transition: transform 500ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n#react-product .track-tile--selected .track-tile__ring {\n  opacity: 1;\n}\n\n#react-product .track-tile--selected .track-tile__media {\n  transform: scale(1.05);\n}\n\n#react-product .track-tile--interactive:active {\n  transform: scale(0.985);\n}\n\n#react-product .track-tile--interactive:focus-visible {\n  outline: 2px solid #ffffff;\n  outline-offset: 3px;\n}\n\n/* Idle hint that the tiles are pickable, offset per tile by --track-tile-wave-index\n   so it travels the grid. It glows rather than touching .track-tile__ring: the ring\n   means \"selected\", so pulsing it here made unchosen tiles read as chosen on a screen\n   whose whole job is showing which ones you picked.\n\n   Deliberately finite. It runs a few passes, then stops, and it is withdrawn entirely\n   once the user engages — a loop on a primary selection screen sits in the corner of\n   the eye while people are trying to read age ranges and height limits, and never lets\n   the device settle. The ramp is slow and the peak sits below the hover glow, so it\n   breathes instead of blinking and never outshines a real interaction.\n\n   The stagger is kept near a third of the 1.2s pulse: much tighter and the four tiles\n   glow in unison, which reads as the grid breathing rather than one crest travelling\n   from the first tile to the last. */\n@keyframes track-tile-hint-glow {\n  0%,\n  33%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(211, 46, 254, 0);\n  }\n\n  17% {\n    box-shadow: 0 0 22px 4px rgba(211, 46, 254, 0.3);\n  }\n}\n\n#react-product .track-tile--waving:not(.track-tile--selected) {\n  animation: track-tile-hint-glow 3.6s ease-in-out 3;\n  animation-delay: calc(0.9s + var(--track-tile-wave-index, 0) * 0.45s);\n}\n\n/* Hover previews the ring at half strength. Gated on a real pointer so touch devices\n   don't latch the hover state after a tap. */\n@media (hover: hover) and (pointer: fine) {\n  /* Deliberately does NOT cancel the hint animation. Suppressing it from inside the\n     hover rule looks right but re-applies the declaration the instant the pointer\n     leaves, and the browser then restarts the hint from its first pass — so the tile\n     glowed for another ten seconds with nothing on it, and every sweep of the mouse\n     across the row wound all four tiles up again. The tile retires the hint in React\n     on first pointer or keyboard contact instead, which cannot be undone by leaving. */\n  #react-product .track-tile--interactive:hover {\n    transform: scale(1.015);\n    box-shadow: 0 12px 32px rgba(211, 46, 254, 0.32);\n  }\n\n  #react-product .track-tile--interactive:not(.track-tile--selected):hover .track-tile__ring {\n    opacity: 0.5;\n  }\n\n  #react-product .track-tile--interactive:not(.track-tile--selected):hover .track-tile__media {\n    transform: scale(1.03);\n  }\n}\n\n/* Room for the glow to land in, kept next to the shadow so the two stay in step.\n   Both selector grids scroll inside a container that clips at its own edges, and the\n   outermost tiles sit hard against them, so those tiles lost the outer half of their\n   glow: Adult Track had none to its left and Mini Track none to its right, while the\n   tiles between them looked right, and the same hover therefore read differently\n   depending on which tile you were on. 36px is the hover shadow's 32px blur radius\n   plus the few pixels the 1.5% hover scale adds on the widest (filling) tiles.\n\n   Sideways only, and not on phones. This screen's vertical space is budgeted to fit\n   four tiles without scrolling (tileHeight in RacingTrackSelection), so padding the\n   rows would push them into a scroll. A phone cannot spare 72px of tile width either,\n   and it loses little by going without: the hover glow needs a fine pointer, so a\n   touch device never paints one, and the fainter idle hint reads fine trailing off the\n   edge of tiles that already run nearly full-bleed. */\n@media (min-width: 640px) {\n  #react-product .selector-tile-grid {\n    padding-left: 36px;\n    padding-right: 36px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  #react-product .track-tile,\n  #react-product .track-tile__ring,\n  #react-product .track-tile__media {\n    transition: none;\n  }\n\n  #react-product .track-tile--waving {\n    animation: none;\n  }\n\n  #react-product .track-tile--interactive:hover,\n  #react-product .track-tile--interactive:active,\n  #react-product .track-tile--selected .track-tile__media {\n    transform: none;\n  }\n}\n\n.swiper-pagination-battle-kart > .swiper-pagination-bullet-active {\n  background: #ea581a !important;\n}\n\n.swiper-pagination-primary-track > .swiper-pagination-bullet {\n  background: #7886ff !important;\n}\n\n#react-product {\n  container-type: inline-size;\n}\n\n#react-product .option-label {\n  height: 24px;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  color: #2f1160;\n}\n\n#react-product p.uppercase {\n  text-transform: uppercase;\n}\n#react-product .progress-bar-arrow {\n  position: absolute;\n  top: 0;\n  right: 0;\n  shape-outside: polygon(0 0, 100% 0, 50% 100%, 0 0);\n  clip-path: polygon(0 0, 100% 0, 50% 100%, 0 0);\n  background: linear-gradient(to right, #e045ff 0%, #e045ff 90%);\n  width: 30px;\n  height: 30px;\n}\n\n#react-product .bg-gradient-1 {\n  background: linear-gradient(126.78deg, #9d62fe 35%, #7886ff 119.7%);\n}\n\n#react-product .bg-gradient-2 {\n  background: linear-gradient(96.73deg, #9d62fe 9.22%, #a852ff 31.45%, #ad44ff 50.38%, #7886ff 88.25%);\n}\n\n/* Phase 2 theme styling — driven by --booking-* CSS vars from data-styling-config */\n.booking-cta-pill {\n  background: var(--booking-cta-bg, linear-gradient(270deg, #f908ff 0%, #d32efe 8.19%, #37ccfb 87.88%, #05fffa 100%));\n  border-radius: var(--booking-cta-radius, 9999px);\n  font-size: var(--booking-cta-font-size, 14px);\n  color: var(--booking-cta-color, #ffffff);\n}\n\n/* Disabled Next/Checkout: solid grey in place of the CTA background, never a dimmed CTA.\n   The label colour is scoped under #react-product so it beats the buttons' tw-text-white. */\n.booking-cta-pill-disabled {\n  background: var(--booking-cta-disabled-bg, #4a4c52);\n  border-radius: var(--booking-cta-radius, 9999px);\n  font-size: var(--booking-cta-font-size, 14px);\n}\n#react-product .booking-cta-pill-disabled,\n#react-product .booking-cta-pill-disabled * {\n  color: var(--booking-cta-disabled-color, #a1a3a9);\n}\n\n/* The outline is what separates Back from a disabled Next, which shares its grey fill.\n   Inset shadow rather than a border so the pill keeps its height. */\n.booking-prev-pill {\n  background: var(--booking-prev-bg, #4a4c52);\n  border-radius: var(--booking-prev-radius, 9999px);\n  font-size: var(--booking-cta-font-size, 14px);\n  color: var(--booking-prev-color, #ffffff);\n  box-shadow: inset 0 0 0 1.5px var(--booking-prev-border, rgba(255, 255, 255, 0.7));\n  transition: filter 0.2s;\n}\n.booking-prev-pill:hover {\n  filter: brightness(1.2);\n}\n\n/* Square on every edge — the expanded summary panel owns the rounding. */\n.booking-sticky-bar {\n  background: var(--booking-sticky-bg, #393b41);\n}\n\n/* Summary surfaces that never take the desktop accent: the expanded panel body and the\n   desktop nav bar flanking it. */\n.booking-sticky-surface {\n  background: var(--booking-sticky-bg, #393b41);\n}\n\n/* Collapsed experience-variant bar blends into the page; desktop keeps the accent below. */\n.booking-sticky-bar.booking-sticky-bar--transparent {\n  background: transparent;\n}\n\n/* Only the full desktop footer (from the `desktop` breakpoint) gets the accent bar; below it the\n   footer is the compact mobile/tablet one and stays transparent. */\n@media (min-width: 1380px) {\n  /* The accent is a collapsed-only treatment. Once expanded, these surfaces sit against\n     the summary panel, so they take the same base colour instead. */\n  .booking-sticky-bar:not(.booking-sticky-bar--expanded) {\n    background: var(--booking-sticky-desktop-accent, var(--booking-sticky-bg, #9d62fe));\n  }\n}\n\n.booking-track-pill {\n  background: var(--booking-pill-bg, linear-gradient(90deg, #00ffff 0%, #ff00ff 100%));\n  color: var(--booking-pill-color, #ffffff);\n  font-size: var(--booking-pill-font-size, 13px);\n  border-radius: var(--booking-pill-radius, 9999px);\n}\n\n#react-product .bg-gradient-3 {\n  background: linear-gradient(126.78deg, #9d62fe 35%, #7886ff 119.7%);\n}\n\n#react-product .selected-swatch-gradient {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);\n}\n\n#react-product .selected-swatch-gradient-1 {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n#react-product .price_15 {\n  background: #40bfff;\n}\n\n#react-product .price_19 {\n  background: #40bfff;\n}\n\n#react-product .price_24 {\n  background: #659aff;\n}\n\n#react-product .price_29 {\n  background: #8a75ff;\n}\n\n#react-product .price_34 {\n  background: #a95ff6;\n}\n\n#react-product .price_39 {\n  background: #c748ee;\n}\n\n#react-product .price_44 {\n  background: #e632e5;\n}\n\n#react-product .price_49 {\n  background: #ff00ff;\n}\n\n#react-product .price_54 {\n  background: #ff0090;\n}\n\n#react-product .price_59 {\n  background: #ff0054;\n}\n#react-product .price_69 {\n  background: #bb1af9;\n}\n\n#react-product .price_250 {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);\n}\n#react-product .price_442 {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);\n}\n\n#react-product .mini-track.price_9 {\n  background: #89d1f9;\n}\n\n#react-product .mini-track.price_14 {\n  background: #8a8df7;\n}\n\n#react-product .mini-track.price_15 {\n  background: #8a8df7;\n}\n\n#react-product .mini-track.price_19 {\n  background: #c64af7;\n}\n\n#react-product .mini-track.price_24 {\n  background: #a9cdf3;\n}\n\n#react-product .mini-track.price_29 {\n  background: #83bcf9;\n}\n\n#react-product .border-color {\n  position: relative;\n  overflow: hidden;\n  z-index: 39;\n  background-image: linear-gradient(282.87deg, #d32efe 14.09%, #05fffa 103.26%);\n  box-shadow: 0 4px 12px rgba(211, 46, 254, 0.3);\n  transform: scale(1.02);\n}\n\n#react-product .border-color .time {\n  /* background: #fff; */\n  height: 100%;\n  /* display: flex;\n    align-items: center;\n    justify-content: center; */\n  width: 100%;\n  margin: auto;\n  /* border-radius: 0.25rem; */\n  z-index: 99;\n}\n\n#react-product .border-color .price-variant {\n  z-index: 5;\n}\n\n#react-product .arrow-up {\n  transform: rotate(180deg);\n}\n\n#react-product .block {\n  margin-bottom: 0 !important;\n}\n\n#react-product .bg-gradient-4 {\n  background: linear-gradient(88.14deg, #ffb82e 18.41%, #ffe600 78.18%);\n}\n#react-product .box-0 {\n  grid-column: auto / span 2;\n}\n#react-product .bg-gradient {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%) !important;\n}\n#react-product .bg-gradient > div > div {\n  color: #fff;\n  background-color: transparent !important;\n}\n#react-product .tw-bg-transparent {\n  background-color: rgba(57, 59, 65, 0) !important;\n}\n#react-product .bg-one {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);\n  opacity: 0.05;\n  border-radius: 60px;\n  padding: 2.61px 3.19px;\n}\n\n#react-product .bg-two {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);\n  opacity: 0.1;\n  border-radius: 60px;\n  padding: 2.5px 2.99px;\n}\n\n#react-product .bg-three {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);\n  opacity: 0.1;\n  border-radius: 34px;\n  padding: 2.36px 3.29px;\n}\n\n#react-product .bg-four {\n  background: linear-gradient(282.87deg, #f908ff 6.14%, #d32efe 14.09%, #37ccfb 91.49%, #05fffa 103.26%);\n  opacity: 0.15;\n  border-radius: 34px;\n  padding: 3.13px 4.26px;\n}\n\n#react-product .arrow.is-top {\n  transform: rotate(225deg);\n}\n#react-product .arrow {\n  display: inline-block;\n  height: 16px;\n  position: absolute;\n  width: 16px;\n  top: -8px;\n  z-index: 9;\n  right: 42px;\n}\n#react-product .arrow.is-triangle::after {\n  border-style: solid;\n  border-width: 0 0 16px 16px;\n  height: 0;\n  width: 0;\n  border-color: transparent;\n  border-bottom-color: #393b41;\n  left: 0;\n  position: absolute;\n  top: 0;\n  content: \"\";\n  display: inline-block;\n}\n#react-product .filter {\n  filter: drop-shadow(0px 0px 40px rgba(0, 0, 0, 0.1));\n}\n\n/* removing library styles */\n\n#react-product .calender.rdrCalendarWrapper {\n  background-color: unset !important;\n}\n#react-product .calender .rdrDayNumber span {\n  color: unset !important;\n}\n#react-product .calender .rdrSelected {\n  color: unset !important;\n}\n\n/* removing library styles end */\n\n#react-product .calender .rdrDateDisplayWrapper {\n  display: none;\n}\n#react-product .calender .rdrMonthAndYearWrapper {\n  padding: 10px 20px;\n  height: auto;\n  background-color: #f3f4f7;\n  display: none;\n}\n#react-product .calender .rdrMonth {\n  padding: 0;\n}\n#react-product .calender .rdrWeekDays {\n  margin-top: 0.5em;\n  margin-bottom: 0.3em;\n  background-color: #000000;\n  color: #c2c0c3;\n  justify-content: space-between;\n  padding: 15px 20px !important;\n  display: flex;\n  gap: 20px;\n}\n#react-product .calender .rdrWeekDay {\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  color: #c2c0c3;\n  flex-basis: calc(100% / 9);\n}\n@container (min-width: 1024px) {\n  #react-product .calender .rdrWeekDay {\n    font-size: 18px;\n  }\n}\n\n#react-product .calender .rdrDay {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n}\n#react-product .calender .rdrDayNumber {\n  font-weight: 600;\n  font-size: 16px;\n  text-transform: uppercase;\n  color: white;\n}\n@container (min-width: 1024px) {\n  #react-product .calender .rdrDayNumber {\n    font-size: 20px;\n  }\n}\n#react-product .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,\n#react-product .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,\n#react-product .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,\n#react-product .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {\n  color: #fdfdfd !important;\n}\n#react-product .calender .rdrDayToday .rdrDayNumber span:after {\n  background: linear-gradient(126.78deg, #9d62fe 35%, #7886ff 119.7%);\n  bottom: 2px;\n}\n#react-product .calender .rdrDays {\n  padding: 20px;\n  display: grid;\n  grid-template-columns: auto auto auto auto auto auto auto;\n  justify-content: space-between;\n  row-gap: 28px;\n}\n@media screen and (max-width: 1024px), (hover: none) and (pointer: coarse) and (max-width: 1379px) {\n  #react-product .calender .rdrDays {\n    row-gap: 10px;\n    padding: 10px;\n  }\n}\n#react-product .calender button.rdrDay {\n  padding: 17px 18px;\n}\n#react-product .calender button.rdrDay.rdrDayDisabled .rdrDayNumber {\n  color: gray;\n}\n\n#react-product .calender button:not(.rdrDayDisabled):not(:has(.rdrSelected)):not(:has(.rdrDayActive)):has(.custom-pricing-cheapest) {\n  background: #01a698 !important;\n  color: white !important;\n}\n\n#react-product .calender button:not(.rdrDayDisabled):not(:has(.rdrSelected)):not(:has(.rdrDayActive)):has(.custom-pricing-medium) {\n  background: #ff9400 !important;\n  color: white !important;\n}\n\n#react-product .calender button:not(.rdrDayDisabled):not(:has(.rdrSelected)):not(:has(.rdrDayActive)):has(.custom-pricing-expensive) {\n  background: #d1435b !important;\n  color: white !important;\n}\n\n/* Dotted outline on Main Track Sprint dates (weekends and holidays), including\n   the neighbouring month's days shown at the edges of the grid. Drawn on ::after\n   so it follows the circular day cell without shifting the existing layout. */\n#react-product .calender button.rdrDay:has(.sprint-track-day) {\n  position: relative;\n}\n#react-product .calender button.rdrDay:has(.sprint-track-day)::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border: 2px dotted #ffffff;\n  border-radius: 100%;\n  pointer-events: none;\n}\n\n#react-product .calender button:has(.rdrSelected),\n#react-product .calender button:has(.rdrDayActive),\n#react-product .calender .rdrInRange,\n#react-product .calender .rdrStartEdge,\n#react-product .calender .rdrEndEdge {\n  top: 0;\n  border-radius: 100%;\n  background: linear-gradient(126.78deg, #9d62fe 35%, #7886ff 119.7%) !important;\n  color: transparent !important;\n  width: 32px;\n  height: 25.6px;\n  display: flex;\n}\n\n#react-product .calender.battle-kart .rdrDayNumber {\n  font-family: \"Source Sans Pro\", sans-serif !important;\n}\n#react-product .calender .rdrNextPrevButton {\n  margin: 0;\n  width: 34px;\n  height: 34px;\n  background: rgba(157, 98, 254, 0.15);\n  border-radius: 8px;\n}\n#react-product .calender .rdrMonthAndYearPickers {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: 0.01em;\n  color: #000000;\n}\n#react-product .calender .rdrNextPrevButton i {\n  display: none;\n}\n#react-product .calender .rdrPprevButton,\n#react-product .calender .rdrNextButton {\n  position: relative;\n}\n#react-product .calender .rdrPprevButton::after,\n#react-product .calender .rdrNextButton::after {\n  position: absolute;\n  content: \"\";\n  left: 50%;\n  top: 50%;\n  background-image: url(../chevron-left.svg);\n  width: 14px;\n  height: 14px;\n  background-repeat: no-repeat;\n  transform: translate(-50%, -50%);\n  background-position: center center;\n}\n#react-product .calender .rdrNextButton {\n  transform: rotate(180deg);\n}\n\n#react-product table,\n#react-product td {\n  border: 1px solid black;\n  border-collapse: collapse;\n}\n#react-product td {\n  padding: 1rem;\n}\n\n#react-product .info-li {\n  display: list-item;\n  margin-left: 2rem;\n  list-style-type: disc;\n}\n\n#react-product .banner-img {\n  min-width: 100%;\n  border: none;\n  overflow: hidden;\n  padding: 0;\n}\n\n@container (max-width: 590px) {\n  #react-product .font-race-champion {\n    font-size: 1.6rem;\n    line-height: 2.4rem;\n  }\n\n  #react-product .font-race-season {\n    font-size: 0.95rem;\n    line-height: 1.09rem;\n  }\n\n  #react-product .font-race-option-label {\n    font-size: 1.4rem;\n    line-height: 2.1rem;\n  }\n\n  #react-product .font-race-accordian-xl {\n    font-size: 1.6rem;\n    line-height: 1.96rem;\n  }\n\n  #react-product .font-race-variant-xs {\n    font-size: 0.8rem;\n    line-height: 1.1rem;\n  }\n\n#react-product .main-track-variant .price-variant,\n#react-product .main-track-variant .seats-left {\n  padding-top: 0;\n  padding-bottom: 0;\n  line-height: 1;\n}\n\n#react-product .main-track-variant .seats-left {\n  display: flex;\n  align-items: center;\n}\n\n#react-product .main-track-variant .seats-left .font-race-variant-xs {\n  line-height: 1;\n}\n\n  #react-product .font-race-variant-xs-date,\n  #react-product .font-race-variant-xs-time {\n    font-size: 1.1rem;\n    line-height: 1.4rem;\n  }\n\n  #react-product .min-height-variant {\n    min-height: 57px;\n  }\n\n  #react-product .padding-t-date {\n    padding-top: 0.8rem;\n  }\n\n  #react-product .padding-b-time {\n    padding-bottom: 0.8rem;\n  }\n\n  #react-product .padding-t-date-click {\n    padding-top: 1.4rem;\n  }\n\n  #react-product .padding-b-time-click {\n    padding-bottom: 1.4rem;\n  }\n\n  #react-product .padding-t-var-block {\n    padding-top: 4rem;\n  }\n\n  #react-product .w-down-icon {\n    width: 9%;\n  }\n}\n\n@container (min-width: 600px) {\n  #react-product .font-race-season {\n    font-size: 1rem;\n    line-height: 1.15rem;\n  }\n\n  #react-product .font-race-bg {\n    font-size: 1.8rem;\n    line-height: 2.8rem;\n  }\n\n  #react-product .font-race-accordian-xl {\n    font-size: 2rem;\n    line-height: 2.4rem;\n  }\n\n  #react-product .font-race-variant-xs {\n    font-size: 1.1rem;\n    line-height: 1.6rem;\n  }\n\n  #react-product .font-race-variant-xs-date {\n    font-size: 1.4rem;\n    line-height: 2rem;\n  }\n\n  #react-product .font-race-variant-xs-time {\n    font-size: 1.2rem;\n    line-height: 1.6rem;\n  }\n\n  #react-product .padding-t-date {\n    padding-top: 1.4rem;\n  }\n\n  #react-product .padding-b-time {\n    padding-bottom: 1.4rem;\n  }\n\n  #react-product .padding-t-date-click {\n    padding-top: 1.6rem;\n  }\n\n  #react-product .padding-b-time-click {\n    padding-bottom: 1.6rem;\n  }\n\n  #react-product .min-height-variant {\n    min-height: 68px;\n  }\n\n  #react-product .padding-t-var-block {\n    padding-top: 6.4rem;\n  }\n\n  #react-product .font-race-champion {\n    font-size: 1.8rem;\n    line-height: 2.8rem;\n  }\n\n  #react-product .w-down-icon {\n    width: 2.4rem;\n  }\n}\n\n/* Medium containers (tablets) */\n@container (min-width: 768px) and (max-width: 1023px) {\n  #react-product .prod-banner-text-align {\n    text-align: center;\n  }\n\n  #react-product .prod-banner-text {\n    font-size: 36px;\n  }\n\n  #react-product .prod-banner-subtext {\n    font-size: 2.4rem;\n    line-height: 2.8rem;\n  }\n\n  #react-product .font-race-season {\n    font-size: 0.95rem;\n    line-height: 1.09rem;\n  }\n}\n\n/* Large containers (iPad-sized) */\n@container (min-width: 1024px) and (max-width: 1279px) {\n  #react-product .heading {\n    padding-top: 2rem;\n  }\n\n  #react-product .font-race-season {\n    font-size: 0.95rem;\n    line-height: 1.09rem;\n  }\n\n  #react-product .prod-banner-text-align {\n    text-align: center;\n  }\n\n  #react-product .prod-banner-text {\n    font-size: 36px;\n  }\n\n  #react-product .prod-banner-subtext {\n    font-size: 2.4rem;\n    line-height: 2.8rem;\n  }\n}\n\n/* Extra large containers (Desktop) */\n@container (min-width: 1280px) {\n  #react-product .font-race-season {\n    font-size: 1rem;\n    line-height: 1.15rem;\n  }\n\n  #react-product .heading {\n    padding-top: 6.4rem;\n    padding-bottom: 3.6rem;\n  }\n\n  #react-product .prod-banner-text-align {\n    text-align: justify;\n  }\n\n  #react-product .prod-banner-text {\n    font-size: 76px;\n  }\n\n  #react-product .prod-banner-subtext {\n    font-size: 3.6rem;\n    line-height: 4rem;\n  }\n}\n\n/* Small to medium containers */\n@container (min-width: 350px) and (max-width: 1366px) {\n  #react-product .prod-banner-text-align {\n    text-align: center;\n  }\n\n  #react-product .prod-banner-text {\n    font-size: 36px;\n  }\n\n  #react-product .prod-banner-subtext {\n    font-size: 2.4rem;\n    line-height: 2.8rem;\n  }\n}\n\n/* Narrow containers */\n@container (min-width: 350px) and (max-width: 920px) {\n  #react-product .heading {\n    padding-top: 2rem;\n  }\n\n  #react-product .font-race-season {\n    font-size: 0.95rem;\n    line-height: 1.09rem;\n  }\n}\n\n#react-product .font-race-lg {\n  font-size: 1.8rem;\n  line-height: 2.8rem;\n}\n\n#react-product .font-race-xl {\n  font-size: 2rem;\n  line-height: 2.4rem;\n}\n\n#react-product .font-race-2xl {\n  font-size: 2.4rem;\n  line-height: 2.8rem;\n}\n\n#react-product .font-race-4xl {\n  font-size: 3.6rem;\n  line-height: 4rem;\n}\n\n#react-product .font-race-sm {\n  font-size: 1.4rem;\n  line-height: 2rem;\n}\n\n#react-product .font-race-base {\n  font-size: 1.6rem;\n  line-height: 2.4rem;\n}\n\n#react-product .font-race-xs {\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n\n#react-product .padding-x-2 {\n  padding-left: 0.8rem;\n  padding-right: 0.8rem;\n}\n\n#react-product .padding-x-2\\.5 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n#react-product .padding-x-3 {\n  padding-left: 1.2rem;\n  padding-right: 1.2rem;\n}\n\n#react-product .padding-1 {\n  padding: 0.4rem;\n}\n\n#react-product .padding-1\\.5 {\n  padding: 0.6rem;\n}\n\n#react-product .padding-4 {\n  padding: 1.6rem;\n}\n\n#react-product .padding-l-5 {\n  padding-left: 2rem;\n}\n\n#react-product .gap-1\\.5 {\n  gap: 0.6rem;\n}\n\n#react-product .gap-2 {\n  gap: 0.8rem;\n}\n\n#react-product .gap-3 {\n  gap: 1.2rem;\n}\n\n#react-product .gap-3\\.5 {\n  gap: 1.4rem;\n}\n\n#react-product .padding-y-1 {\n  padding-top: 0.6rem;\n  padding-bottom: 0.6rem;\n}\n\n#react-product .padding-y-2 {\n  padding-top: 0.8rem;\n  padding-bottom: 0.8rem;\n}\n\n#react-product .padding-y-2\\.5 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n#react-product .padding-x-4 {\n  padding-left: 1.6rem;\n  padding-right: 1.6rem;\n}\n\n#react-product .padding-x-5 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n#react-product .padding-y-3 {\n  padding-top: 1.2rem;\n  padding-bottom: 1.2rem;\n}\n\n#react-product .padding-y-4 {\n  padding-top: 1.6rem;\n  padding-bottom: 1.6rem;\n}\n\n#react-product .padding-x-10 {\n  padding-left: 4rem;\n  padding-right: 4rem;\n}\n\n#react-product .padding-x-14 {\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n\n#react-product .padding-x-16 {\n  padding-left: 6.4rem;\n  padding-right: 6.4rem;\n}\n\n#react-product .padding-t-2\\.5 {\n  padding-top: 1rem;\n}\n\n#react-product .padding-t-4 {\n  padding-top: 1.6rem;\n}\n\n#react-product .padding-b-16 {\n  padding-bottom: 6.4rem;\n}\n\n#react-product .max-width-block {\n  max-width: 44.8rem;\n}\n\n#react-product .width-6 {\n  width: 2.4rem;\n}\n\n#react-product .height-6 {\n  height: 2.4rem;\n}\n\n#react-product .rounded-xl {\n  border-radius: 1.2rem;\n}\n\n#react-product .rounded {\n  border-radius: 0.4rem;\n}\n\n#react-product .rounded-t {\n  border-top-left-radius: 0.4rem;\n  border-top-right-radius: 0.4rem;\n}\n\n#react-product .rounded-bl {\n  border-bottom-left-radius: 0.4rem;\n}\n#react-product .rounded-br {\n  border-bottom-right-radius: 0.4rem;\n}\n\n/* Touch tablets get the small-iPad layout (see TOUCH_TABLET_QUERY in layoutViewport.ts),\n   so the page container stops at the small-iPad width too. */\n@media (hover: none) and (pointer: coarse) and (max-width: 1379px) {\n  #react-product .tw-container {\n    max-width: 768px;\n  }\n}\n\n/* Mobile-specific enhancements */\n@media (max-width: 768px), (hover: none) and (pointer: coarse) and (max-width: 1379px) {\n  #react-product .border-color {\n    box-shadow: 0 6px 16px rgba(211, 46, 254, 0.4);\n    transform: scale(1.03);\n  }\n\n  /* Improve touch targets */\n  #react-product .variant-block {\n    min-height: 60px !important;\n    touch-action: manipulation;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  /* Better visual feedback for selected state */\n  #react-product .variant-block.selected {\n    border: 2px solid #d32efe;\n    box-shadow: 0 4px 12px rgba(211, 46, 254, 0.3);\n  }\n\n  /* Pressed state for better touch feedback */\n  #react-product .variant-block:active {\n    transform: scale(0.98);\n    transition: transform 0.1s ease;\n  }\n\n  /* Prevent text selection on touch */\n  #react-product .variant-block {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  /* Prevent Swiper from interfering with variant block clicks */\n  #react-product .swiper-slide {\n    touch-action: pan-y;\n  }\n\n  #react-product .swiper-slide > div {\n    touch-action: manipulation;\n  }\n\n  /* Ensure variant blocks have proper touch handling */\n  #react-product .swiper-slide .tw-touch-manipulation {\n    touch-action: manipulation !important;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  /* Prevent Swiper pagination from interfering */\n  #react-product .swiper-pagination {\n    pointer-events: auto;\n    touch-action: manipulation;\n  }\n\n  #react-product .swiper-pagination-bullet {\n    touch-action: manipulation;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
